/**
 * Avalara © 2017
 * file: engines/opus_ui/src/actions/auth.js
 */

import config from '../config';
import { getBaseUrlFromConfig } from '../utils/url_helpers';
import { getJwt, setJwt, removeJwt, setReturnUrl } from '../utils/store';

export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

export function loginUserSuccess() {
  return { type: LOGIN_USER_SUCCESS };
}

export function logoutUser() {
  try {
    removeJwt();
    broadcastLogoutEvent();
  } catch (e) {
    console.error('Error occured while trying to logout a user');
  }

  return { type: LOGOUT_USER_SUCCESS };
}

export function forceLogin() {
  const loginUrl = `${getBaseUrlFromConfig(config.biztechApi)}/auth/login`;
  const returnUrl = `${getBaseUrlFromConfig(config.appSettings)}`;

  if (window.location.hash) {
    try {
      setReturnUrl(window.location.hash);
    } catch (e) {
      // console.error('forceLogin()', e);
    }
  }

  window.location.replace(`${loginUrl}?returnUrl=${returnUrl}`);
}

export function authEventHandler() {
  const authChannel = new BroadcastChannel('opus_auth');

  authChannel.postMessage({ message: 'OPUS_NEW_TAB' });

  authChannel.onmessage = function (event) {
    const token = getJwt();

    switch (event.data.message) {
      case 'OPUS_NEW_TAB':
        if (token) {
          authChannel.postMessage({ message: 'OPUS_JWT', token });
        }
        break;

      case 'OPUS_JWT':
        if (!token) {
          setJwt(event.data.token);
        }
        break;

      case 'OPUS_LOGOUT':
        window.location = '/#logout';
        break;

      default:
        break;
    }
  };
}

function broadcastLogoutEvent() {
  const authChannel = new BroadcastChannel('opus_auth');
  authChannel.postMessage({ message: 'OPUS_LOGOUT' });
}
